import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const changeValueSchema = z
  .union([z.string(), z.number(), z.boolean(), z.array(z.unknown()), z.record(z.unknown())])
  .nullable();

const advertisementHistoryChangeSchema = z.object({
  field: z.string(),
  from: changeValueSchema,
  to: changeValueSchema,
});

const advertisementHistoryEntrySchema = z.object({
  timestamp: z.string(),
  user_id: z.number().nullable(),
  entity_type: z.string(),
  entity_id: z.number(),
  action: z.string(),
  changes: z.array(advertisementHistoryChangeSchema),
  full_name: z.string().nullable(),
  email: z.string().nullable(),
  entity_name: z.string().nullable(),
});

const advertisementHistoryResponseSchema = z.array(advertisementHistoryEntrySchema);

const adHistoryEntityTypesResponseSchema = z.object({
  entity_types: z.array(z.string()),
});

export type AdvertisementHistoryEntry = z.infer<typeof advertisementHistoryEntrySchema>;

export const advertisementHistoryApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getAdvertisementHistory",
    method: "get",
    path: "/ads/:advertisement_id/history/",
    parameters: [
      {
        name: "advertisement_id",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "days",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "n",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "entity_types",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    status: 200,
    response: advertisementHistoryResponseSchema,
  })
    .addEndpoint({
      alias: "getAdHistoryEntityTypes",
      method: "get",
      path: "/ads/history/entity_types/",
      response: adHistoryEntityTypesResponseSchema,
    })
    .build(),
);
